var N=o=>{throw TypeError(o)};var z=(o,p,e)=>p.has(o)||N("Cannot "+e);var u=(o,p,e)=>(z(o,p,"read from private field"),e?e.call(o):p.get(o)),x=(o,p,e)=>p.has(o)?N("Cannot add the same private member more than once"):p instanceof WeakSet?p.add(o):p.set(o,e),g=(o,p,e,t)=>(z(o,p,"write to private field"),t?t.call(o,e):p.set(o,e),e),c=(o,p,e)=>(z(o,p,"access private method"),e);import{B as H}from"./chunk-BaseElement-DfPOIVeB.js";import{s as Q,u as K}from"./chunk-collection-filters-Bpe6eZ9D.js";import{c as J,s as Y,f as X}from"./chunk-filter-mapper-CJuUw8FV.js";import{c as Z}from"./chunk-debug-logger-qBBIvuzh.js";import{p as ee,r as te,n as R,a as se}from"./chunk-normalize-filters-YAIRo3dh.js";import{d as ie,e as re,f as ae}from"./chunk-swatch-catalog-DFHaX_32.js";import{U as D}from"./chunk-url-state-manager-Bm1AE9tt.js";import{s as ne}from"./chunk-search-Btfms9hx.js";import{x as d,T as $}from"./chunk-lit-element-C4bBeaiV.js";import{c as le}from"./chunk-repeat-CRCwEczY.js";import"./chunk-api-client-Ct07m346.js";import"./chunk-store-config-CT52BuQj.js";import"./chunk-storefront-access-token-C5-ATWPI.js";import"./chunk-shopify-id-utils-eStUXT8g.js";import"./chunk-client-Ds2_M1fa.js";import"./chunk-harness-Bby5MadC.js";import"./chunk-cache-FIWmp_iO.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-BTk4h7vC.js";const O="filter.v.option.",oe=/^filter\.[pv]\.m\./;function ce(o){const p=[o.gqlOptionName];return o.filterType==="variantOption"&&p.push(o.shopifyTarget),p.filter(e=>!!e).map(e=>e.toLowerCase())}function de(o){return o.filterType==="variantOption"||o.filterType==="price"?"":Q(o.shopifyTarget??"").key}function pe(o,p){if(p.startsWith(O)){const t=p.slice(O.length).toLowerCase();return ce(o).includes(t)}if(!oe.test(p))return!1;const e=de(o);return e!==""&&ee(p)===e}function ue(o,p){const e=p.find(s=>pe(o,s.paramName));if(e)return{filter:e,matchedBy:"target"};const t=p.find(s=>s.label===o.name);return t?{filter:t,matchedBy:"label"}:null}const w=Z("CollectionGrid");var b,k,S,C,v,f,L,l,B,I,M,_,V,q,j,U,E,W,G,A,T,P;class he extends H{constructor(){super();x(this,l);x(this,b);x(this,k);x(this,S);x(this,C);x(this,v);x(this,f);x(this,L);this.collectionHandle="",this.autoApply=!1,this._filterData=[],this._pendingSelections=null,this._previewCount=null,this._referenceData={colorCategories:[],swatches:[],materials:[],leadTimes:[],filterTemplate:null},this._loading=!0,this._totalCount=0,g(this,b,new Set),g(this,v,null),g(this,f,null),g(this,L,Math.random().toString(36).slice(2,8)),g(this,k,c(this,l,U).bind(this))}static get properties(){return{collectionHandle:{type:String,attribute:"collection-handle"},autoApply:{type:Boolean,attribute:"auto-apply"},_filterData:{state:!0},_loading:{state:!0},_totalCount:{state:!0},_pendingSelections:{state:!0},_previewCount:{state:!0}}}connectedCallback(){super.connectedCallback(),c(this,l,q).call(this),c(this,l,j).call(this);const e=parseInt(this.getAttribute("total-count")||"0",10);e>0&&(this._totalCount=e),g(this,S,c(this,l,B).bind(this)),g(this,C,c(this,l,I).bind(this)),window.addEventListener("collection:updated",u(this,k)),window.addEventListener("urlstate:change",u(this,S)),window.addEventListener("modal-dialog::close",u(this,C))}disconnectedCallback(){var e;super.disconnectedCallback(),window.removeEventListener("collection:updated",u(this,k)),window.removeEventListener("urlstate:change",u(this,S)),window.removeEventListener("modal-dialog::close",u(this,C)),u(this,f)&&clearTimeout(u(this,f)),(e=u(this,v))==null||e.abort()}_handleChange(e){const t=e.target;if(!this.autoApply){if(!t.name||!t.name.startsWith("filter."))return;const i=new Map(this._pendingSelections??c(this,l,M).call(this));i.has(t.name)||i.set(t.name,new Set);const r=i.get(t.name);t.checked?r.add(t.value):(r.delete(t.value),r.size===0&&i.delete(t.name)),this._pendingSelections=i,c(this,l,V).call(this);return}if(!t.name||!t.name.startsWith("filter."))return;const s=D.getParams();if(t.type==="checkbox"){const i=s.getAll(t.name).flatMap(r=>r.split(",")).map(r=>r.trim()).filter(Boolean);if(t.checked)i.push(t.value);else{const r=i.indexOf(t.value);r!==-1&&i.splice(r,1)}s.delete(t.name);for(const r of i)s.append(t.name,r)}else t.value?s.set(t.name,t.value):s.delete(t.name);c(this,l,T).call(this,s)}_handleSubmit(e){e.preventDefault();const t=e.target,s=new URLSearchParams,i=D.getParams();for(const a of["q","type","sort_by"]){const n=i.get(a);n&&s.set(a,n)}if(this._pendingSelections)for(const[a,n]of this._pendingSelections)for(const h of n)s.append(a,h);else{const a=t.querySelectorAll('input[type="checkbox"]');for(const n of a)n.checked&&n.name.startsWith("filter.")&&s.append(n.name,n.value)}const r=t.querySelectorAll('input[type="hidden"]:not([disabled])');for(const a of r)a.name.startsWith("filter.")&&s.append(a.name,a.value);this._pendingSelections=null,this._previewCount=null,this.$emit("modal-dialog::close","v2-filter-drawer-dialog"),c(this,l,T).call(this,s)}_handleReset(e){var r;e.preventDefault(),this._pendingSelections=new Map,this._previewCount=null;const t=this.querySelector("price-range-filter");(r=t==null?void 0:t.resetToDefaults)==null||r.call(t);const s=new URLSearchParams,i=D.getParams();for(const a of["q","type","sort_by"]){const n=i.get(a);n&&s.set(a,n)}c(this,l,T).call(this,s)}_handlePriceChange(e){const t=e.detail;if(!t)return;if(this.autoApply){const i=D.getParams();t.minValue!==void 0&&t.minValue>0?i.set("filter.v.price.gte",String(t.minValue)):i.delete("filter.v.price.gte"),t.maxValue!==void 0?i.set("filter.v.price.lte",String(t.maxValue)):i.delete("filter.v.price.lte"),c(this,l,T).call(this,i);return}const s=new Map(this._pendingSelections??c(this,l,M).call(this));s.delete("filter.v.price.gte"),s.delete("filter.v.price.lte"),t.minValue!==void 0&&t.minValue>0&&s.set("filter.v.price.gte",new Set([String(t.minValue)])),t.maxValue!==void 0&&s.set("filter.v.price.lte",new Set([String(t.maxValue)])),this._pendingSelections=s}render(){if(this._loading)return this._renderSkeleton();const e=c(this,l,G).call(this),t=`collection-filters-form-${u(this,L)}`;return d`
      <form
        id="${t}"
        class="flex w-full flex-col"
        @change=${this._handleChange}
        @submit=${this._handleSubmit}
        @reset=${this._handleReset}
        @price-change=${this._handlePriceChange}
      >
        <div
          class="border-t-ui-lines-2 bg-t-background text-t-foreground w-full flex-1 border-t lg:border-x"
        >
          ${le(e,s=>c(this,l,A).call(this,s),s=>this._renderFilter(s))}
        </div>
        ${this.autoApply?$:d`
                <div
                  class="gap-xs border-t-ui-lines-2 bg-t-background px-sm py-xs sticky bottom-0 z-10 grid w-full grid-cols-[68%_30%] justify-center border-t border-solid"
                >
                  <button
                    class="btn min-w-none!"
                    variant="primary"
                    type="submit"
                  >
                    Apply (${this._previewCount??this._totalCount})
                  </button>
                  <button
                    class="btn min-w-none! border-t-foreground! bg-t-brand-primary-contrast px-xs! border!"
                    variant="tertiary"
                    type="reset"
                  >
                    Clear All
                  </button>
                </div>
              `}
      </form>
    `}_renderSkeleton(){return d`
      <div
        class="border-t-ui-lines-2 bg-t-background text-t-foreground w-full border-t lg:border-x"
      >
        ${[1,2,3,4,5].map(()=>d`
            <div
              class="border-t-ui-lines-2 px-sm py-lg md:py-md animate-pulse border-b"
            >
              <div class="bg-t-background-secondary h-4 w-1/3 rounded"></div>
            </div>
          `)}
      </div>
    `}_renderFilter(e){switch(e.type){case"boolean":return this._renderBooleanFilter(e);case"list":return this._renderListFilter(e);case"price_range":return this._renderPriceRangeFilter(e);default:return $}}_renderBooleanFilter(e){var r,a;const t=e.values.some(n=>c(this,l,_).call(this,n)),s=e.trueValue??((r=e.values.find(n=>n.value==="true"||n.value==="1"))==null?void 0:r.value)??((a=e.values[0])==null?void 0:a.value)??"",i=e.values.every(n=>n.count===0&&!n.active);return d`
      <div class="border-t-ui-lines-2 px-sm py-lg md:py-md border-b">
        <slide-toggle
          name="${e.paramName}"
          value="${s}"
          label="${e.label}"
          wrapper-class="flex items-center justify-between flex-row-reverse"
          label-class="uppercase"
          .checked=${t}
          ?disabled=${i}
        ></slide-toggle>
      </div>
    `}_renderListFilter(e){const t=c(this,l,A).call(this,e);return d`
      <details
        class="js-filter group/filter-dropdown border-t-ui-lines-2 px-sm cursor-pointer border-b"
        ?open=${u(this,b).has(t)}
        @toggle=${s=>{s.target.open?u(this,b).add(t):u(this,b).delete(t)}}
      >
        <summary class="focus-inset py-lg md:py-md flow-root">
          <div class="flex w-full items-center justify-between">
            <span class="caption-large uppercase">${e.label}</span>
            <span
              class="ml-sm text-t-foreground flex cursor-pointer items-center"
            >
              <svg-icon
                src="icon-plus-sm"
                class="group-[[open]]/filter-dropdown:hidden"
                style="--icon-size: 14px; stroke-width: 2;"
                aria-hidden="true"
              ></svg-icon>
              <svg-icon
                src="icon-minus-sm"
                class="hidden group-[[open]]/filter-dropdown:block"
                style="--icon-size: 14px; stroke-width: 2;"
                aria-hidden="true"
              ></svg-icon>
            </span>
          </div>
        </summary>
        <div class="pb-6">
          ${t==="lumber-color"?this._renderColorSwatchGrid(e):t==="materials"?this._renderMaterialCards(e):e.paramName.includes("lead_time")?this._renderLeadTimeOptions(e):this._renderCheckboxList(e)}
        </div>
      </details>
    `}_renderCheckboxList(e){const t=c(this,l,P).call(this,e);return d`
      <ul class="list-unstyled space-y-xs" role="list">
        ${t.map(s=>{const i=s.count===0&&!s.active;return d`
            <li>
              <label
                class="group/checkbox ${i?"opacity-50":""} gap-xs flex cursor-pointer items-center py-1"
              >
                <span
                  class="relative inline-flex size-4 shrink-0 items-center justify-center"
                >
                  <input
                    type="checkbox"
                    name="${s.paramName}"
                    value="${s.value}"
                    .checked=${c(this,l,_).call(this,s)}
                    ?disabled=${i}
                    class="peer border-t-foreground disabled:border-t-border size-4 cursor-pointer appearance-none rounded-[1px] border transition-all focus-visible:outline-0 disabled:cursor-auto"
                  />
                  <svg-icon
                    src="icon-checkbox-tick"
                    class="text-t-foreground peer-disabled:text-t-disabled pointer-events-none absolute opacity-0 peer-checked:opacity-100"
                    style="--icon-size: 12px;"
                    aria-hidden="true"
                  ></svg-icon>
                </span>
                <span
                  class="${i?"text-t-disabled!":""} body-14! text-t-foreground! capitalize!"
                >
                  <span>${s.label}</span> (${s.count})
                  ${s.image?d`
                          <span class="mt-1 block">
                            <svg-icon
                              src="${s.image}"
                              class="block"
                              style="--icon-size: 126px;"
                              aria-hidden="true"
                            ></svg-icon>
                          </span>
                        `:null}
                </span>
              </label>
            </li>
          `})}
      </ul>
    `}_renderColorSwatchGrid(e){const{colorCategories:t,swatches:s}=this._referenceData;if(!t.length)return this._renderCheckboxList(e);const i=new Map;for(const a of e.values){const n=a.label.toLowerCase().replace(/[^a-z0-9]+/g,"-");i.set(n,a)}const r=new Map;for(const a of s)r.set(a.handle,a);return d`
      ${t.map(a=>{const n=(a.colors||[]).map(h=>{const m=r.get(h),y=i.get(h);return m&&y?{swatch:m,filterValue:y}:null}).filter(Boolean);return n.length===0?$:d`
          <div>
            ${a.title?a.image?d`
                      <div
                        class="mb-xs border-t-ui-lines-2 text-t-brand-primary-contrast flex min-h-[60px] w-full items-center justify-center border bg-cover bg-center bg-repeat"
                        style="background: url('${a.image}');"
                      >
                        ${a.title}
                      </div>
                    `:d`
                      <div
                        class="mb-xs border-t-ui-lines-2 text-t-foreground flex min-h-[60px] w-full items-center justify-center border"
                      >
                        ${a.title}
                      </div>
                    `:$}
            ${a.description?d`
                    <p class="caption mb-xs text-t-foreground text-center">
                      ${a.description}
                    </p>
                  `:$}
            <div class="mb-md gap-2xs grid grid-cols-2">
              ${n.map(({swatch:h,filterValue:m})=>{const y=m.count===0&&!m.active;return d`
                  <label class="block cursor-pointer" tabindex="0">
                    <input
                      type="checkbox"
                      name="${m.paramName}"
                      value="${m.value}"
                      .checked=${c(this,l,_).call(this,m)}
                      ?disabled=${y}
                      class="peer hidden"
                    />
                    <div
                      class="gap-xs border-t-ui-lines-2 p-2xs text-t-foreground peer-checked:border-t-foreground-secondary peer-checked:text-t-foreground-secondary peer-disabled:text-t-disabled flex items-center border"
                    >
                      ${h.image?d`
                              <img
                                src="${h.image}"
                                class="h-10 w-10 min-w-10"
                                alt="${h.name}"
                                width="40"
                                height="40"
                                loading="lazy"
                              />
                            `:d`
                              <div
                                class="h-10 w-10 min-w-10"
                                style="background-color:${h.color}"
                              >
                                <span class="sr-only">${h.name}</span>
                              </div>
                            `}
                      <h5 class="caption">${h.name}</h5>
                    </div>
                  </label>
                `})}
            </div>
          </div>
        `})}
    `}_renderMaterialCards(e){const{materials:t}=this._referenceData,s=c(this,l,P).call(this,e),i=r=>{const a=r.toLowerCase();return t.find(n=>n.value.toLowerCase()===a)??t.find(n=>{const h=n.value.toLowerCase();return h.includes(a)||a.includes(h)||a==="polywood"&&h==="lumber"})};return d`
      <p
        class="caption mb-sm text-t-brand-secondary-contrast max-w-[337px] md:max-w-full"
      >
        All furniture features POLYWOOD, our proprietary climate-tested lumber.
        Explore all styles and mixed-material options below.
      </p>
      <ul class="list-unstyled space-y-xs" role="list">
        ${s.map(r=>{const a=i(r.label)||{value:r.label,image:null,description:""},n=r.count===0&&!r.active;return d`
            <li>
              <label
                class="block max-w-[286px] cursor-pointer md:max-w-full"
                tabindex="0"
              >
                <input
                  type="checkbox"
                  name="${r.paramName}"
                  value="${r.value}"
                  .checked=${c(this,l,_).call(this,r)}
                  ?disabled=${n}
                  class="peer hidden"
                />
                <div
                  class="${n?"opacity-50":""} gap-xs text-t-foreground peer-checked:border-t-foreground peer-checked:bg-t-brand-primary-contrast peer-disabled:text-t-disabled border-t-ui-lines-2 p-2xs flex items-center border bg-transparent"
                >
                  ${a.image?d`
                          <img
                            src="${a.image}"
                            alt="${r.label}"
                            loading="lazy"
                            class="size-16 shrink-0 object-cover"
                          />
                        `:d`
                          <div
                            class="border-t-ui-lines-2 bg-t-background size-16 shrink-0 border"
                          ></div>
                        `}
                  <div class="min-w-0">
                    <h5
                      class="text-t-brand-secondary-contrast caption mb-2xs text-[13px]"
                    >
                      ${r.label} (${r.count})
                    </h5>
                    ${a.description?d`<div
                            class="text-t-brand-secondary-contrast text-xs"
                          >
                            ${a.description}
                          </div>`:$}
                  </div>
                </div>
              </label>
            </li>
          `})}
      </ul>
    `}_renderLeadTimeOptions(e){const{leadTimes:t}=this._referenceData,s=c(this,l,P).call(this,e),i=new Map;for(const r of t)i.set(r.type,r.text);return d`
      <ul class="list-unstyled space-y-xs" role="list">
        ${s.map(r=>{const a=r.count===0&&!r.active,n=i.get(r.label)||r.label;return d`
            <li>
              <label
                class="group/checkbox ${a?"opacity-50":""} gap-xs flex cursor-pointer items-center py-1"
              >
                <input
                  type="checkbox"
                  name="${r.paramName}"
                  value="${r.value}"
                  .checked=${c(this,l,_).call(this,r)}
                  ?disabled=${a}
                  class="border-t-foreground accent-t-foreground-secondary h-4 w-4"
                />
                <span
                  class="${a?"text-t-disabled!":""} body-14! text-t-foreground! capitalize!"
                >
                  <span>${n}</span> (${r.count})
                </span>
              </label>
            </li>
          `})}
      </ul>
    `}_renderCheckboxItem(e){const t=e.count===0&&!e.active;return d`
      <li>
        <label
          class="group/checkbox ${t?"opacity-50":""} gap-xs flex cursor-pointer items-center py-1"
        >
          <input
            type="checkbox"
            name="${e.paramName}"
            value="${e.value}"
            .checked=${c(this,l,_).call(this,e)}
            ?disabled=${t}
            class="border-t-foreground accent-t-foreground-secondary h-4 w-4"
          />
          <span
            class="${t?"text-t-disabled!":""} body-14! text-t-foreground! capitalize!"
          >
            <span>${e.label}</span> (${e.count})
            ${e.image?d`
                    <span class="mt-1 block">
                      <svg-icon
                        src="${e.image}"
                        class="block h-auto"
                        style="--icon-size: 126px;"
                        aria-hidden="true"
                      ></svg-icon>
                    </span>
                  `:null}
          </span>
        </label>
      </li>
    `}_renderPriceRangeFilter(e){const t=e.rangeMax?Math.round(e.rangeMax/100):0,s=c(this,l,A).call(this,e);return d`
      <details
        class="js-filter group/filter-dropdown border-t-ui-lines-2 px-sm cursor-pointer border-b"
        ?open=${u(this,b).has(s)}
        @toggle=${i=>{i.target.open?u(this,b).add(s):u(this,b).delete(s)}}
      >
        <summary class="focus-inset py-lg md:py-md flow-root">
          <div class="flex w-full items-center justify-between">
            <span class="caption-large uppercase">${e.label}</span>
            <span
              class="ml-sm text-t-foreground flex cursor-pointer items-center"
            >
              <svg-icon
                src="icon-plus-sm"
                class="group-[[open]]/filter-dropdown:hidden"
                style="--icon-size: 14px; stroke-width: 2;"
                aria-hidden="true"
              ></svg-icon>
              <svg-icon
                src="icon-minus-sm"
                class="hidden group-[[open]]/filter-dropdown:block"
                style="--icon-size: 14px; stroke-width: 2;"
                aria-hidden="true"
              ></svg-icon>
            </span>
          </div>
        </summary>
        <div class="pb-sm">
          <price-range-filter
            min="0"
            max="${t}"
            min-value="0"
            max-value="${t}"
            value="${t}"
            currency="$"
            class="w-full"
            collection-id="${this.collectionHandle}"
          >
            <input type="hidden" name="filter.v.price.gte" value="0" disabled />
            <input
              type="hidden"
              name="filter.v.price.lte"
              value="${t}"
              disabled
            />
          </price-range-filter>
        </div>
      </details>
    `}}b=new WeakMap,k=new WeakMap,S=new WeakMap,C=new WeakMap,v=new WeakMap,f=new WeakMap,L=new WeakMap,l=new WeakSet,B=function(){this._filterData=te(this._filterData)},I=function(e){var s;e.detail==="v2-filter-drawer-dialog"&&(this._pendingSelections=null,this._previewCount=null,u(this,f)&&clearTimeout(u(this,f)),(s=u(this,v))==null||s.abort())},M=function(){const e=new Map;for(const t of this._filterData)for(const s of t.values)s.active&&(e.has(s.paramName)||e.set(s.paramName,new Set),e.get(s.paramName).add(s.value));return e},_=function(e){var t;return this._pendingSelections!==null?((t=this._pendingSelections.get(e.paramName))==null?void 0:t.has(e.value))??!1:e.active},V=function(){var e;if(u(this,f)&&clearTimeout(u(this,f)),(e=u(this,v))==null||e.abort(),!this._pendingSelections||this._pendingSelections.size===0){this._previewCount=null;return}g(this,f,setTimeout(async()=>{const t=new URLSearchParams;for(const[i,r]of this._pendingSelections)for(const a of r)t.append(i,a);const s=K(`?${t.toString()}`);if(s.length===0){this._previewCount=null;return}g(this,v,new AbortController);try{const i=document.querySelector("collection-grid"),r=(i==null?void 0:i.hasAttribute("nosto-enabled"))??!1,a=(i==null?void 0:i.getAttribute("collection-id"))??"",n=(i==null?void 0:i.getAttribute("collection-title"))??"",h=(i==null?void 0:i.getAttribute("search-query"))??"";let m=null;if(r&&J(s)){const y=Y(s),F=await ne({query:h||void 0,categoryId:h?void 0:a||void 0,categoryPath:h?void 0:n||void 0,size:1,from:0,filter:y==null?void 0:y.filter,facets:[],signal:u(this,v).signal});(F==null?void 0:F.total)!=null&&(m=F.total)}m==null&&(m=(await X({handle:this.collectionHandle,filters:s,signal:u(this,v).signal})).productIds.length),this._previewCount=m}catch(i){i.name!=="AbortError"&&w("warn","Preview count fetch failed:",i)}},300))},q=function(){var r,a,n,h;const e=document.getElementById("filter-reference-data");if(e)try{this._referenceData={...this._referenceData,...JSON.parse(e.textContent||"{}")}}catch(m){w("error","Failed to parse filter-reference-data",m)}const t=ie();t&&(this._referenceData.colorCategories=t.colorCategories,this._referenceData.swatches=t.swatches);const s=re();s&&(this._referenceData.materials=s);const i=ae();i&&(this._referenceData.leadTimes=i),w("log","Reference data loaded",{colors:((r=this._referenceData.colorCategories)==null?void 0:r.length)??0,swatches:((a=this._referenceData.swatches)==null?void 0:a.length)??0,materials:((n=this._referenceData.materials)==null?void 0:n.length)??0,leadTimes:((h=this._referenceData.leadTimes)==null?void 0:h.length)??0,hasTemplate:!!this._referenceData.filterTemplate,colorSource:t?"catalog":"legacy blob"})},j=function(){const e=document.getElementById("collection-filter-data");if(e)try{const t=JSON.parse(e.textContent||"[]");this._filterData=t.map(R),this._loading=!1,w("log","SSR filters loaded",{count:this._filterData.length,labels:this._filterData.map(s=>s.label)})}catch(t){w("error","Failed to parse collection-filter-data",t)}},U=function(e){const t=e.detail;t&&(t.totalCount!=null&&(this._totalCount=t.totalCount),t.filters&&(t.isSSR?this._filterData=t.filters.map(s=>R(s)):this._filterData=t.filters.map(s=>se(s,this._filterData)),this._pendingSelections=null,this._previewCount=null,this._loading=!1,w("log",`Filters updated (${t.isSSR?"SSR":"GQL"})`,{count:this._filterData.length,totalCount:this._totalCount})))},E=function(e){var s;const t=this._referenceData.filterTemplate;return((s=t==null?void 0:t.featured_filters)==null?void 0:s.includes(e.label))??!1},W=function(e,t){const s=ue(e,t);if(!s){w("warn","Referenced facet matched no live filter and was dropped",{facet:e.handle,shopifyTarget:e.shopifyTarget,name:e.name});return}return s.matchedBy==="label"&&e.shopifyTarget&&w("warn","Facet target matched no live filter; fell back to its label",{facet:e.handle,shopifyTarget:e.shopifyTarget,filterType:e.filterType,matchedParamName:s.filter.paramName}),s.filter},G=function(){const e=this._filterData.filter(r=>!c(this,l,E).call(this,r)),t=this._referenceData.filterTemplate,s=this._referenceData.sidebarFacets??[];if(s.length>0){const r=s.map(n=>c(this,l,W).call(this,n,e)).filter(n=>n!=null),a=[...new Set(r)];if(w("log","Sidebar resolved from facet references",{referenced:s.length,rendered:a.length}),a.length>0)return a}const i=(t==null?void 0:t.left_column_filters)??(t==null?void 0:t.filters)??[];return i.length===0?e:i.map(r=>e.find(a=>a.label===r)).filter(r=>r!=null)},A=function(e){return e.label.toLowerCase().replace(/[^a-z0-9]+/g,"-")},T=function(e){e.delete("page"),D.push(e.toString())},P=function(e){if(e.operator==="AND"){const t=e.values.filter(i=>i.active),s=e.values.filter(i=>!i.active);return[...t,...s]}return e.values};customElements.define("collection-filters",he);
